module.exports = __webpack_public_path__ + "static/img/mobile.2593c718.png";